import React from "react";
import { Home } from "./pages/Home";
type EventsState = "upcoming" | "empty";
type AppProps = {
  showReviewNotes?: boolean;
  eventsState?: EventsState;
};
export function App({
  showReviewNotes = true,
  eventsState = "upcoming"
}: AppProps) {
  return <Home showReviewNotes={showReviewNotes} showEmptyEvents={eventsState === "empty"} data-id="element-0" data-mp="3k7i5d7s1k63r" />;
}